<template>
<div class="p-fluid">
    <div class="p-col-12 p-lg-12">
<div class="card card-w-title">
  <div class="p-formgrid">
    <div class="group-permission-title">
     
      <Toolbar class="fixed-bottom-toolbar" >
      <template slot="left">
        <div  class="manager-title" v-if="this.mode == 'add'">Cài đặt trễ hẹn văn bản</div>
        <div class="manager-title" v-else>Cài đặt trễ hẹn văn bản</div>
      </template>
      <template slot="right">
        <!-- <Button
          label="Quay lại"
          @click="backToList()"
          class="p-button-warning"
        /> -->
        <Button
          v-if="mode == 'edit'"
          :label="'Lưu thay đổi'"
          @click="saveData()"
          class="p-button-success"
        />
        <Button
          v-else
          :label="'Lưu thay đổi'"
          @click="saveData()"
          class="p-button-success"
        />
      </template>
    </Toolbar>
    </div>
      <div class="card card-w-body">
        <p style="font-weight: bold;">Số ngày tính trễ hẹn kể từ ngày nhận văn bản từ cơ quan ( ngày 1)</p>
        <div class="p-field p-grid" style="padding-top: 15px;">
          <div class="p-col-12 p-grid" v-for="status in listStatus" :key="status.id" >
            <div v-if="status.code != 'TLT'" class="p-grid p-col-12" style="margin-bottom: 30px; margin-top: 10px;">
              <div class="p-col-6 p-grid">
                <label class="p-col-4 txt-left">HĐTĐ {{status.name}}</label>
                <div class="p-col-8">
                  <InputText v-model="status.delay_time"  id="delay_time" type="number" class="p-col-width" placeholder="Nhập số ngày tính trễ hẹn" />
                  <small
                    v-if="validationErrors && validationErrors[status.code]"
                    class="p-invalid"
                  >{{validationErrors[status.code]}}</small>
                </div>
              </div>
              <div class="p-col-3 p-grid">
                <label class="p-col-6 txt-left">Ngày cảnh báo</label>
                <div class="p-col-6">
                  <InputText v-bind:value="status.delay_time - 2"  type="number" class="p-col-width" :disabled="true" />

                </div>
              </div>
              <div class="p-col-3 p-grid">
                <label class="p-col-6 txt-left">Ngày tính trễ</label>
                <div class="p-col-6">
                  <InputText v-bind:value="status.delay_time - (-1)"  type="number" class="p-col-width" :disabled="true" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>
    </div>
</div>
</template>

<script>
// import DataServices from '@/core/DataServices'
// import moment from "moment-timezone";
import gql from "graphql-tag";
export default {
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      validationErrors: {},
      formMode: this.mode,
      listStatus: []
    }
  },
  mounted() {
    // if (this.$route.params.id !== undefined) {
    //   this.holiday_setting_id = this.$route.params.id
    // }
    // // console.log('this.group_permission_id', this.group_permission_id)
  },
  methods: {
    backToList() {
      this.$emit('back');
    },
    async validateData() {
      console.log('-------------------------------')
      this.validationErrors = {};
      var has_error = false
      for (let i = 0; i < this.listStatus.length; i++) {
        const e = this.listStatus[i];
        if (e.delay_time == '') {
          this.validationErrors[e.code] = 'Vui lòng nhập ngày trễ hẹn của HTTĐ '+e.name;
          has_error = true
        }
      }
      return has_error
    },
    async analyzeData() {
      console.log('dâdadadadadadad')
      var data_item= []
      for (let i = 0; i < this.listStatus.length; i++) {
          const item = this.listStatus[i]
          var data_item_item= {}
          data_item_item['code'] = item.code
          data_item_item['name'] = item.name
          data_item_item['delay_time'] = item.delay_time
          data_item.push(data_item_item)
        }
      return data_item
    },
    async saveData() {
      if (await this.validateData()) {
        // console.log('true')
        return;
      }
      console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
      if (this.mode == 'add') {
        // this.$store.commit("setLoading", true);

        var data_delay_time = await this.analyzeData()
        console.log('data delay time', data_delay_time)
        var query = `mutation update_delay_time($objects: [status_tongdat_insert_input!]!) {
          insert_status_tongdat(objects: $objects,
              on_conflict: {
                constraint: status_tongdat_code_key,
                update_columns: [delay_time]
              }
          ) {
            affected_rows
          }
        }`;
        console.log("query", query);
        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              objects: data_delay_time
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Lưu dữ liệu thành công",
                life: 4000
              });
              this.displayDialog = false;
              // var that = this
              setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-status_tongdat/add'
              }, 3000)
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      }
    },
  },
  apollo: {
    status_tongdat: {
      query() {
        let query = `
          query MyQuery($id: Int) {
            status_tongdat {
              id
              name
              code
              delay_time
            }
          }
        `
        return gql(query);
      },
      variables() {
      },
      update(data) {
        if(data.status_tongdat){
          this.listStatus = data.status_tongdat
        }
      },
      fetchPolicy: "network-only",
    },
  }
}
</script>

<style lang="scss">
  .p-multiselect {
    width: 450px;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .card.card-w-body {
    background-color: #FAFAFA;
    // padding: 1em;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  
  </style>
